<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadCustomerList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="customerList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="cellphone"></el-table-column>
      <el-table-column label="车牌号" prop="carNo"></el-table-column>
      <el-table-column label="性别" width="60">
        <template #default="{row}">
          <div v-loading="$isLoading('Gender')">{{row.gender | valueName('Gender')}}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime"></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column width="80" align="center">
        <template #header>
          <el-button v-if="addable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <edit-customer-dialog :visible.sync="dialog.show" :customer="dialog.customer"
                          :read-only="readOnly"></edit-customer-dialog>
  </div>
</template>

<script>
  import EditCustomerDialog from '@/views/customer/EditCustomerDialog'
  import { Customer } from '@/store/objdef/objectDef'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import authority from '@/utils/authority'

  export default {
    name: 'CustomerList',
    mixins: [shareDataMixin],
    components: { EditCustomerDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          customer: new Customer()
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('customer/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.customer = new Customer()
        this.dialog.show = true
      },
      edit (customer) {
        this.dialog.customer = this.$_.cloneDeep(customer)
        this.dialog.show = true
      },
      deleteCustomer (customer) {
        this.$confirm(`确认删除客户【${customer.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('customer/delete', customer).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadCustomerTemplate'
      },
      customerList () {
        const list = this.$store.state.customer.customerList
        if (!this.searchText) return list

        return list.filter(customer => customer.name.indexOf(this.searchText) !== -1)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_CUSTOMER)
      },
      addable () {
        return this.$hasPermission(authority.ADD_CUSTOMER)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
